export const TABLE_TITLES = [
    { content: '#', width: '1%', align: 'center' },
    { content: 'Date', width: '10%', align: 'center' },
    { content: 'VRM', width: '5%', align: 'center' },
    { content: 'Bike', align: 'left' },
    { content: 'Year', width: '4%', align: 'center' },
    { content: 'Mileage', width: '5%', align: 'center' },
    { content: 'CC', width: '4%', align: 'center' },
    { content: 'Valuation', width: '6%', align: 'center' },
    { content: 'Margin', width: '6%', align: 'center' },
    { content: 'Status', width: '8%', align: 'center' },
    { content: 'Telephone', width: '7%', align: 'center' },
    { content: 'Name', width: '10%', align: 'left' },
    { content: 'Division', width: '5%', align: 'center' },
    { content: 'Assigned', width: '1%', align: 'center' },
    { content: 'Action', width: '5%', align: 'center' },
    { content: 'Assign', width: '5%', align: 'center' },
];

export const TABLE_TITLES_DELIVERY_REQUESTED = [
    { content: '#', width: '1%', align: 'center' },
    { content: 'Date', width: '10%', align: 'center' },
    { content: 'VRM', width: '5%', align: 'center' },
    { content: 'Bike', align: 'left' },
    { content: 'Year', width: '4%', align: 'center' },
    { content: 'Mileage', width: '5%', align: 'center' },
    { content: 'CC', width: '4%', align: 'center' },
    { content: 'Valuation', width: '6%', align: 'center' },
    { content: 'Margin', width: '6%', align: 'center' },
    { content: 'Status', width: '8%', align: 'center' },
    { content: 'Telephone', width: '7%', align: 'center' },
    { content: 'Name', width: '10%', align: 'left' },
    { content: 'Postcode', width: '7%', align: 'center' },
    { content: 'County', width: '10%', align: 'left' },
    { content: 'Division', width: '5%', align: 'center' },
    { content: 'Assigned', width: '1%', align: 'center' },
];



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/contants/table_titles.constants.js